import React from "react";
import { AsideContainer, Logo, CloseBtn } from "./index.style";
import Navigation from "../sideNavigation";

const Sidebar = ({ data, isOpen, onClose }) => {
  return (
    <AsideContainer className={isOpen ? "mobile-open" : ""}>
      <Logo>
        <img src="/images/acta-logo.png" alt="Acta" />
      </Logo>
      <CloseBtn onClick={onClose}>&times;</CloseBtn>
      <Navigation data={data} onNavigate={onClose} />
    </AsideContainer>
  );
};

export default Sidebar;
